import React from 'react';
import { Box, IconButton, Tooltip, Button, useTheme, alpha } from '@mui/material';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import TableViewOutlinedIcon from '@mui/icons-material/TableViewOutlined';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';

const FormListToolbar = ({ handleAdd, handleExportToExcel, handleExportToPdf, handleExportToCsv, disableExport, disableAdd }) => {
  const theme = useTheme();

  return (
    <Box 
      display="flex" 
      justifyContent="space-between" 
      alignItems="center" 
      mb={2}
      sx={{
        gap: 1,
        flexWrap: 'wrap',
      }}
    >
      {!disableAdd ? (
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddCircleOutlineOutlinedIcon />}
          onClick={handleAdd}
          sx={{
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 600,
            boxShadow: theme.shadows[2],
            '&:hover': {
              boxShadow: theme.shadows[4],
              transform: 'translateY(-1px)',
            },
            transition: 'all 0.2s ease-in-out',
          }}
        >
          Προσθήκη
        </Button>
      ) : (
        <Box />
      )}

      {!disableExport && (
        <Box 
          display="flex" 
          gap={0.5}
          sx={{
            backgroundColor: alpha(theme.palette.primary.main, 0.08),
            borderRadius: 2,
            padding: 0.5,
          }}
        >
          <Tooltip title="Εξαγωγή σε Excel">
            <IconButton 
              color="primary" 
              onClick={handleExportToExcel}
              sx={{
                borderRadius: 1.5,
                '&:hover': {
                  backgroundColor: alpha(theme.palette.primary.main, 0.12),
                },
              }}
            >
              <FileDownloadOutlinedIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Εξαγωγή σε PDF">
            <IconButton 
              color="primary" 
              onClick={handleExportToPdf}
              sx={{
                borderRadius: 1.5,
                '&:hover': {
                  backgroundColor: alpha(theme.palette.primary.main, 0.12),
                },
              }}
            >
              <PictureAsPdfOutlinedIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Εξαγωγή σε CSV">
            <IconButton 
              color="primary" 
              onClick={handleExportToCsv}
              sx={{
                borderRadius: 1.5,
                '&:hover': {
                  backgroundColor: alpha(theme.palette.primary.main, 0.12),
                },
              }}
            >
              <TableViewOutlinedIcon />
            </IconButton>
          </Tooltip>
        </Box>
      )}
    </Box>
  );
};

export default FormListToolbar;
